import React from "react";
import { useNavigate } from "react-router-dom";
import CommonNavbar from "../../Common/CommonLayout/CommonNavbar";
import { ToastContainer } from "react-toastify";
import { Card, Form, Row, Col, Container, Button } from "react-bootstrap";
import { API_URL } from "../../../Constant";
import ClientNavbar from "../ClientLayout/ClientNavbar";
import ClientSidebar from "../ClientLayout/ClientSidebar";
import ClientFooter from "../ClientLayout/ClientFooter";
import Badge from "react-bootstrap/Badge";
import Stack from "react-bootstrap/Stack";

const ClientProfile = () => {
    const navigate = useNavigate();

    return (
        <>
            <ClientNavbar />
            <div className="d-flex justify-content-center mt-4">
                <ToastContainer />
                <ClientSidebar />
                <Container fluid className="p-4">
                    <div style={{ paddingLeft: "30px", width: "100%" }}>


                        <h2 className="cheading">Profile</h2>


                        <Card
                            style={{
                                width: "700px",
                                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                                border: "1px solid lightgray",
                                borderRadius: "10px",
                                padding: "20px",
                            }}
                        >
                            <Card.Body>
                                <Form>
                                    <div className="row">
                                        <div
                                            className="col-md-3 d-flex align-items-center"
                                            style={{ paddingBottom: "20px" }}
                                        >
                                            {/* <img
                                                src={`${API_URL}api/Login/GetImageByImageURL/${profilePictureUrl.replace(
                                                    "images/",
                                                    ""
                                                )}`}
                                                alt="User"
                                                style={{
                                                    width: "180px",
                                                    height: "180px",
                                                }}
                                                onError={(e) => {
                                                    console.log("Image load error:", e);
                                                    e.target.onerror = null; // Prevent infinite loop
                                                }}
                                            /> */}
                                        </div>
                                        <div
                                            className="col-md-8"
                                            style={{ textAlign: "left", padding: "60px" }}
                                        >
                                            <b>
                                                <h5 className="p-0 m-0">
                                                    {/* <b>{counsellorName}</b> */}
                                                </h5>
                                            </b>
                                            {/* <p className="p-0 m-0">{bio}</p> */}
                                            <hr />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div
                                            className="col-md-12 d-flex align-items-center flex-wrap"
                                            style={{
                                                textAlign: "left",
                                                paddingTop: "10px",
                                                gap: "10px",
                                                paddingLeft: "50px",
                                                paddingRight: "50px",
                                            }}
                                        >
                                            <strong>Expertise :</strong>
                                            <Stack
                                                direction="horizontal"
                                                gap={10}
                                                style={{ flexWrap: "wrap" }}
                                            >
                                                <Badge pill bg="info" text="light">
                                                    {/* {expertise} */}
                                                </Badge>

                                            </Stack>
                                        </div>
                                    </div>
                                    <br />
                                    <div className="row">
                                        <div
                                            className="col-md-6"
                                            style={{ paddingLeft: "50px", paddingRight: "50px" }}
                                        >
                                            <Form.Group className="mb-2">
                                                <Form.Label>
                                                    <b>Languages Known :</b>
                                                    {/* {language} */}
                                                </Form.Label>
                                            </Form.Group>
                                            <Form.Group className="mb-2">
                                                <Form.Label>
                                                    <b>Religion : </b>
                                                    {/* {religion} */}
                                                </Form.Label>
                                            </Form.Group>
                                            <Form.Group className="mb-2">
                                                <Form.Label>
                                                    <b>Age : </b>
                                                    {/* {age} */}
                                                </Form.Label>
                                            </Form.Group>

                                            <Form.Group className="mb-2">
                                                <Form.Label>
                                                    <b>Gender : </b>
                                                    {/* {gender} */}
                                                </Form.Label>
                                            </Form.Group>
                                            <Form.Group className="mb-2">
                                                <Form.Label>
                                                    <b>Counselling Type : </b> Individual.
                                                </Form.Label>
                                            </Form.Group>
                                        </div>
                                        <div
                                            className="col-md-6"
                                            style={{ paddingLeft: "50px", paddingRight: "50px" }}
                                        >
                                            <Form.Group className="mb-2">
                                                <Form.Label>
                                                    <b>Country : </b>
                                                    {/* {countryName} */}
                                                </Form.Label>
                                            </Form.Group>
                                            <Form.Group className="mb-2">
                                                <Form.Label>
                                                    <b>State :</b>
                                                    {/* {stateName} */}
                                                </Form.Label>
                                            </Form.Group>
                                            <Form.Group className="mb-2">
                                                <Form.Label>
                                                    <b>Education : </b>
                                                    {/* {masterDegree} */}
                                                </Form.Label>
                                            </Form.Group>
                                            <Form.Group className="mb-2">
                                                <Form.Label>
                                                    <b>Qualification : </b>
                                                    {/* {mdUniversity} */}
                                                    (MA)
                                                </Form.Label>
                                            </Form.Group>
                                        </div>
                                    </div>
                                    <div
                                        className="col-md-12"
                                        style={{ paddingLeft: "35px", paddingRight: "35px" }}
                                    >
                                        <Form.Group className="mb-12">
                                            <Form.Label>
                                                <b>Experience : </b>
                                                {/* {yearsOfExperience} */}
                                            </Form.Label>
                                        </Form.Group>
                                    </div>
                                    <br />
                                    <div
                                        className="col-md-12 d-flex align-items-center gap-4 flex-wrap justify-content-between"
                                        style={{ paddingLeft: "35px" }}
                                    >
                                        {/* Select Duration */}
                                        <Form.Group className="d-flex align-items-center">
                                            <Form.Label className="me-2">
                                                <b>Duration: </b>
                                            </Form.Label>
                                            <Form.Select
                                                aria-label="Default select example"
                                                className="form-control"
                                                disabled
                                                style={{ marginLeft: "5px" }}
                                            >
                                                <option>60 Min.</option>
                                            </Form.Select>
                                        </Form.Group>

                                        {/* Amount */}
                                        <Form.Group
                                            className="align-items-left"
                                            style={{ paddingLeft: "100px" }}
                                        >
                                            <Form.Label>
                                                <b>Fees:</b> 100 $
                                            </Form.Label>
                                        </Form.Group>
                                    </div>

                                    <br />
                                    <br />
                                    <center>
                                        {/* <Button variant="primary" type="button" onSubmit={handleBookAppointment(counsellorId)}> */}

                                    </center>
                                </Form>
                            </Card.Body>
                        </Card>


                    </div>

                    <h1>Client Profile</h1>

                </Container>
            </div>
            <ClientFooter />
        </>
    );
};

export default ClientProfile;
